var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('span',{staticClass:"animate-spin h-12 w-12 border-4 border-orange-400 border-t-white rounded-full"})])
}]

export { render, staticRenderFns }